import React from 'react';
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";


export default function WideSelectionSection() {
  return (
    <>
    <Box component={'container'}>
    <Box
          sx={{
            display: 'flex',
            flexDirection: {lg: 'row', md: 'row', sm: 'column', xs: 'column'},
            // alignItems: "center",
            justifyContent: "center",
            marginTop: "132px",
            marginBottom: "40px"

          }}
        >
          
            <Box>
              <Typography
                sx={{
                  maxWidth: "620px",
                  // width: {lg: "620px", md: "480px", sm: "550px", xs: "550px"},
                //   width: "100%",
                  // height: "78px",
                  fontSize: {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                  fontWeight: "600",
                  lineHeight: {lg: "56px", md: "56px", sm: "56px", xs: "40px"},
                  letterSpacing: "0.01em",
                  justifyContent: 'center',
                  // marginRight: "24px",
                }}
              >
                A wide selection of services to suit your needs
              </Typography>
            </Box>
          
          
            <Box>
              <Typography
                sx={{
                  // width: "620px",
                //   width: "100%",
                  // height: "112px",
                  fontSize: {lg: "18px", md: "18px", sm: "16px", xs : "16px"},
                  fontWeight: "400",
                  lineHeight: "145%",
                  letterSpacing: "0.015em",
                  justifyContent: 'center',
                  width: {lg: "620px", md: "540px", sm: "100%", xs: "100%"}
                  
                  // marginRight: "88px",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s.
              </Typography>
            </Box>
          
          </Box>
        </Box>
    </>
  )
}
